<template>
	<TemplateBase :is-sales="isSales">
		<div
			v-if="pageTitle"
			class="bg-gradient-to-r from-purple-700 to-purple-900 top-0 py-24 lg:py-32 w-full flex items-center relative h-[50vh]"
		>
			<LazyAtomImage
				img-class="absolute w-full h-full left-0 top-0 object-cover"
				:src="heroImage.src"
				:alt="heroImage.alt"
				:quality="80"
			/>
			<div
				class="absolute top-0 right-0 bottom-0 left-0 from-brand-900 to-brand-900/0 bg-gradient-to-r mix-blend-multiply"
			/>
			<div class="container flex flex-col gap-8 z-10">
				<h1
					class="text-white drop-shadow-lg font-display text-display-size-xs lg:text-display-size-sm font-bold"
				>
					{{ pageTitle }}
				</h1>
				<LazyAtomBreadcrumbs
					v-if="breadcrumbs"
					:breadcrumbs="breadcrumbs"
					class="text-functional-size-sm"
				/>
			</div>
		</div>
		<slot />
	</TemplateBase>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { ImageType } from '#base/core/types/ImageType';

defineProps<{
	heroImage: ImageType;
	pageTitle: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
